import { LoadingOutlined } from "@ant-design/icons";
import { Checkbox, Radio, Spin } from "antd";
import { searchParamsFilters } from "constants/phase";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import { CloseModal } from "../../../components/icons";
import { aspectRatioClip, audios, graphics } from "../../../config";

const antIcon = <LoadingOutlined style={{ fontSize: 24, align: "center" }} spin />;

const Filter = (props) => {
  const {
    loader,
    filterOpen,
    setFilters,
    searchParams,
    setSearchParams,
    setFilterOpen,
    activeTab,
    finalFilters,
    setFinalFilters,
    updatedSearchParams,
  } = props;
  const [applyFilter, setApplyFilter] = useState(0);
  const closearFilterModal = () => {
    setFilterOpen(false);
    setFilters(JSON.parse(searchParams.get("filters")) || searchParamsFilters);
    setFinalFilters(JSON.parse(searchParams.get("filters")) || searchParamsFilters);
  };

  useEffect(() => {
    if (applyFilter > 0) {
      closearFilterModal();
      updatedSearchParams.set("filters", JSON.stringify(finalFilters));
      setSearchParams(updatedSearchParams);
    }
  }, [applyFilter]);

  useEffect(() => {
    setFilters(JSON.parse(searchParams.get("filters")) || searchParamsFilters);
    setFinalFilters(JSON.parse(searchParams.get("filters")) || searchParamsFilters);
  }, [searchParams]);

  const onChangeAspectRatio = (e) => {
    const ratio = e.target.value;
    const ratios = activeTab === "bumper" ? [...finalFilters?.bumperratios] : [...finalFilters?.overlayratios];
    if (!ratios.includes(ratio)) {
      ratios.push(ratio);
    } else {
      _.pull(ratios, ratio);
    }
    const updatedFilters = {
      ...finalFilters,
      bumperratios: activeTab === "bumper" ? ratios : finalFilters.bumperratios,
      overlayratios: activeTab === "overlay" ? ratios : finalFilters.overlayratios,
    };
    setFinalFilters(updatedFilters);
  };

  const setSortValue = (e) => {
    setFinalFilters({
      ...finalFilters,
      bumpersort: activeTab === "bumper" ? e : finalFilters?.bumpersort,
      graphicsort: activeTab === "graphic" ? e : finalFilters?.graphicsort,
      overlaysort: activeTab === "overlay" ? e : finalFilters?.overlaysort,
      audiosort: activeTab === "audio" ? e : finalFilters?.audiosort,
    });
  };

  const onChangesGraphics = (e) => {
    const graphic = e.target.value;
    let graphicformats = [];
    graphicformats = finalFilters?.graphicformats;
    if (!finalFilters?.graphicformats.includes(graphic)) {
      graphicformats.push(graphic);
    } else {
      _.pull(graphicformats, graphic);
    }
    setFinalFilters({ ...finalFilters, graphicformats });
  };
  const onChangesAudios = (e) => {
    const audio = e.target.value;
    const audios = finalFilters?.audioformats;
    if (!finalFilters?.audioformats.includes(audio)) {
      audios.push(audio);
    } else {
      _.pull(audios, audio);
    }
    const audioformats = audios;
    setFinalFilters({ ...finalFilters, audioformats });
  };
  return (
    <Modal
      isOpen={filterOpen}
      ariaHideApp={false}
      onRequestClose={closearFilterModal}
      contentLabel="Filter Modal"
      portalClassName="react-modal"
      overlayClassName="modal"
      shouldCloseOnOverlayClick={false}
      className="modal-dialog react-modal-dialog-sm modal-dialog-centered filter-modal custom-small-modal"
    >
      <div className="modal-content">
        <div className="react-modal-header">
          <h5 className="react-modal-title">Filters</h5>
          <button type="button" onClick={closearFilterModal} className="btn btn__default">
            <CloseModal />
          </button>
        </div>
        <div className="react-modal-body">
          <div className="filter-column-container filter-grid-container">
            <div className="filter-column">
              <div className="titleblock">
                <h6>Sort By</h6>
              </div>
              <div className="custom-radio-group">
                <Radio.Group
                  name="radiogroup"
                  value={
                    activeTab === "bumper"
                      ? finalFilters?.bumpersort
                      : activeTab === "graphic"
                        ? finalFilters?.graphicsort
                        : activeTab === "audio"
                          ? finalFilters?.audiosort
                          : finalFilters?.overlaysort
                  }
                  onChange={(e) => {
                    setSortValue(e.target.value);
                  }}
                  defaultValue="earliest"
                >
                  <Radio value={-1}> Earliest</Radio>
                  <Radio value={1}> Oldest</Radio>
                </Radio.Group>
              </div>
            </div>
            {(activeTab === "graphic" || activeTab === "audio") && (
              <div className="filter-column">
                <div className="titleblock mb-0">
                  <h6>File type</h6>
                </div>
                <div className="checkbox-container-main">
                  <div className="content-control-block long styled-scroll">
                    <div className="custom-radio-group">
                      <Checkbox.Group
                        className="text-capitalize"
                        value={activeTab === "graphic" ? finalFilters?.graphicformats : finalFilters?.audioformats}
                      >
                        {" "}
                        {activeTab === "graphic" &&
                          graphics.map((graphic, index) => (
                            <Checkbox
                              value={graphic.value}
                              key={index}
                              onChange={onChangesGraphics}
                              className="text-capitalize"
                              checked={(finalFilters?.graphicformats || []).includes(graphic.value)}
                            >
                              {graphic.name}
                            </Checkbox>
                          ))}
                        {activeTab === "audio" &&
                          audios.map((audio, index) => (
                            <Checkbox
                              value={audio.value}
                              key={index}
                              onChange={onChangesAudios}
                              className="text-capitalize"
                              checked={(activeTab === "overlay" ? finalFilters.audioformats : []).includes(audio.value)}
                            >
                              {audio.name}
                            </Checkbox>
                          ))}
                      </Checkbox.Group>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab !== "graphic" && activeTab !== "audio" && (
              <div className="filter-column">
                <div className="titleblock mb-0">
                  <h6>Aspect Ratio</h6>
                </div>
                <div className="checkbox-container-main">
                  <div className="content-control-block long styled-scroll">
                    <div className="custom-radio-group">
                      <Checkbox.Group
                        className="text-capitalize"
                        value={activeTab === "bumper" ? finalFilters?.bumperratios : finalFilters?.overlayratios}
                      >
                        {(activeTab === "bumper" || activeTab === "overlay") &&
                          aspectRatioClip &&
                          aspectRatioClip.map(
                            (ratio, index) =>
                              index !== 0 && ( // Exclude the first item
                                <Checkbox
                                  checked={(activeTab === "overlay"
                                    ? finalFilters?.bumperratios
                                    : finalFilters?.overlayratios || []
                                  ).includes(ratio.value)}
                                  value={ratio.value}
                                  key={index}
                                  onChange={onChangeAspectRatio}
                                >
                                  {ratio.name}
                                </Checkbox>
                              ),
                          )}
                      </Checkbox.Group>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="react-modal-footer">
          <button
            type="button"
            onClick={() => {
              setApplyFilter((previous) => previous + 1);
            }}
            className="btn btn-primary"
          >
            Apply
            {loader ? <Spin indicator={antIcon}></Spin> : ""}
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default Filter;
